<meta-title i18n>הודעה נשלחה אליך במייל</meta-title>

<div class="auth-page">
  <header class="auth-page-header">
    <h2 i18n>סיסמה חדשה למייל</h2>
  </header>

  <div class="auth-card">
    <p i18n>שלחנו לך בדוא"ל שאיתו נרשמת ובהודעת SMS קישור לאיפוס סיסמה.</p>

    <p *ngIf="_emailAddress" i18n>
      כתובת הדוא"ל שלך המעודכנת במערכת היא:
      <span dir="ltr">{{ _emailAddress }}</span>
    </p>

    <p i18n>לאחר הכניסה לקישור תקבל סיסמה חדשה שאיתה תוכל להכנס למערכת.</p>

    <p i18n>
      בברכה,
      <br />
      מערכות מידע
    </p>
  </div>
</div>
